/**
 * Vitals Tabs Fix - Prevent page scroll/jump when clicking tabs
 * This keeps the right side product form anchored and prevents jumping
 */
(function() {
  'use strict';
  
  // Function to prevent scroll on Vitals tab clicks
  function preventVitalsScroll() {
    // Find all Vitals tab/accordion elements
    const vitalsTabs = document.querySelectorAll(
      '#vitals-tabs-placeholder .vt-tab, ' +
      '#vitals-tabs-placeholder .vt-accordion-item, ' +
      '[id*="vitals-tabs"] .vt-tab, ' +
      '[id*="vitals-tabs"] .vt-accordion-item, ' +
      '[data-vitals-tabs] .vt-tab, ' +
      '[data-vitals-tabs] .vt-accordion-item'
    );
    
    vitalsTabs.forEach(function(tab) {
      // Prevent default scroll behavior on click
      tab.addEventListener('click', function(e) {
        // Store current scroll position
        const scrollY = window.scrollY;
        
        // Prevent any scrollIntoView calls
        const originalScrollIntoView = Element.prototype.scrollIntoView;
        Element.prototype.scrollIntoView = function() {
          // Do nothing - prevent scrolling
          return;
        };
        
        // Restore scroll position after a brief delay
        setTimeout(function() {
          window.scrollTo(0, scrollY);
          Element.prototype.scrollIntoView = originalScrollIntoView;
        }, 10);
      }, { passive: false });
    });
  }
  
  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preventVitalsScroll);
  } else {
    preventVitalsScroll();
  }
  
  // Also run after a delay to catch dynamically loaded Vitals content
  setTimeout(preventVitalsScroll, 1000);
  setTimeout(preventVitalsScroll, 3000);
  
  // Use MutationObserver to watch for dynamically added Vitals content
  const observer = new MutationObserver(function(mutations) {
    let shouldReattach = false;
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (
            node.id && node.id.includes('vitals') ||
            node.querySelector && node.querySelector('[id*="vitals"], [data-vitals-tabs]')
          )) {
            shouldReattach = true;
          }
        });
      }
    });
    
    if (shouldReattach) {
      preventVitalsScroll();
    }
  });
  
  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
